import { camelizeKeys } from 'humps';
import qs from 'query-string';
import { createAsyncGet } from './httpClientUtils';
import { makeGetRatingUrl } from '../utils/urlProvider';

class RatingApi {
  getRating = createAsyncGet({
    urlFactory: (requestObj) => {
      const query = qs.stringify(requestObj);
      return makeGetRatingUrl(query);
    },
    withCredentials: true,
    transformResponseFunc: data => camelizeKeys(data),
  });
}

export default new RatingApi();
